import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var StyledUpload = styled(Box)(function () { return ({}); });

export { StyledUpload as default };
//# sourceMappingURL=index.styled.js.map
